import { AlertHandle, NotifyProps } from './Alert';

class AlertController {
  handle: AlertHandle | undefined;

  setImperativeHandle = (_handle: AlertHandle) => {
    this.handle = _handle;
  };

  notify = (props: NotifyProps) => {
    this.handle?.notify(props);
  };

  dismiss = () => {
    this.handle?.dismiss();
  };
}

const alertController = new AlertController();

export const setImperativeHandle = alertController.setImperativeHandle;
export const notify = alertController.notify;
export const dismiss = alertController.dismiss;
